
    <div fieldmagicGridRow>
      <div fieldmagicGridColumn="12">
        <div class="d-flex flex-column d-flex-gap w-100">
          <div class="d-flex justify-content-end w-100">
            <fieldmagic-dropdown-input
              *ngIf="filterable"
              [(ngModel)]="filter"
              class="w-20"
              [standalone]="true"
              placeholder="Please select filter"
              [options]="filters$ | async"
              [clearable]="false"
              (ngModelChange)="onFilterChange()"
            >
            </fieldmagic-dropdown-input>
          </div>

          <table class="table table-bordered">
            <thead>
              <tr>
                <td
                  width="30%"
                >
                  <fieldmagic-text
                    content="Defect"
                    purpose="table-header"
                  >
                  </fieldmagic-text>
                </td>
                <td
                  width="26%"
                >
                  <fieldmagic-text
                    content="Comments"
                    purpose="table-header"
                  >
                  </fieldmagic-text>
                </td>
                <td
                  width="5%"
                >
                  <fieldmagic-text
                    content="Acknowledged?"
                    purpose="table-header"
                    alignment="center"
                  >
                  </fieldmagic-text>
                </td>
                <td
                  width="5%"
                >
                  <fieldmagic-text
                    content="Resolved?"
                    purpose="table-header"
                    alignment="center"
                  >
                  </fieldmagic-text>
                </td>
                <td
                  width="10%"
                >
                  <fieldmagic-text
                    content="Job"
                    purpose="table-header"
                    alignment="center"
                  >
                  </fieldmagic-text>
                </td>
                <td
                  width="10%"
                >
                  <fieldmagic-text
                    content="Quote"
                    purpose="table-header"
                    alignment="center"
                  >
                  </fieldmagic-text>
                </td>
                <td
                  width="16%"
                >
                  <fieldmagic-text
                    content="Date Reported"
                    purpose="table-header"
                  >
                  </fieldmagic-text>
                </td>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngIf="fetching$ | async">
                <tr class="text-center">
                  <td colspan="3">
                    <fieldmagic-icon [spin]="true"></fieldmagic-icon>
                  </td>
                </tr>
              </ng-container>

              <ng-container *ngIf="! (fetching$ | async)">
                <ng-container *ngIf="faults$ | async as faults">
                  <tr
                    *ngIf="faults | blank"
                    class="text-center"
                  >
                    <td colspan="7">No actual defects recorded.</td>
                  </tr>

                  <ng-container *ngFor="let fault of faults; let fault_index = index">
                    <tr>
                      <td
                        [style.background]="fault.color"
                        [style.color]="fault.color | bg_text_color"
                      >
                        {{ '(%s) %s' | sprintf: [fault.severity, fault.fault] }}
                      </td>

                      <td>
                        {{ fault.comments | placeholdWithString }}
                      </td>

                      <td class="text-center">
                        <div class="d-flex d-flex-gap w-100 justify-content-center">
                          <span>{{ (fault.acknowledged ? 'yes' : 'no') | translate }}</span>

                          <fieldmagic-icon
                            *ngIf="fault.acknowledged"
                            [icon]="[{
                              icon: 'info-circle',
                              klass: 'text-info'
                            }]"
                            [tooltip]="'Acknowledged By: %s' | translate | sprintf: [fault.acknowledged_by_text]"
                          >
                          </fieldmagic-icon>
                        </div>
                      </td>

                      <td>
                        <div class="d-flex d-flex-gap w-100 justify-content-center">
                          <span>{{ (fault.resolved ? 'yes' : 'no') | translate }}</span>

                          <fieldmagic-icon
                            *ngIf="fault.resolved"
                            [icon]="[{
                              icon: 'info-circle',
                              klass: 'text-info'
                            }]"
                            tooltip="View resolution details"
                            purpose="clicking"
                            (click)="onViewResolutionDetails(fault)"
                          >
                          </fieldmagic-icon>
                        </div>
                      </td>

                      <td class="text-center">
                        <ng-container *ngIf="fault | data_get: 'job_text' | filled">
                          <a
                            [routerLink]="['/jobs', fault.job_id]"
                            target="_blank"
                          >{{ '#%s' | sprintf: [fault.job_text] }}</a>
                        </ng-container>

                        <ng-container *ngIf="fault | data_get: 'job_text' | blank">
                          --
                        </ng-container>
                      </td>

                      <td class="text-center">
                        <ng-container *ngIf="fault | data_get: 'opportunity_text' | filled">
                          <a
                            [routerLink]="['/opportunities', fault.opportunity_id]"
                            target="_blank"
                          >{{ '#%s' | sprintf: [fault.opportunity_text] }}</a>
                        </ng-container>

                        <ng-container *ngIf="fault | data_get: 'opportunity_text' | blank">
                          <span>--</span>
                        </ng-container>
                      </td>

                      <td>
                        <div class="d-flex d-flex-gap align-items-center w-100">
                          <span>{{ fault.date_reported | format: 'll' }}</span>

                          <fieldmagic-icon
                            [icon]="[{
                              icon: 'info-circle',
                              klass: 'text-info'
                            }]"
                            tooltip="View report details"
                            purpose="clicking"
                            (click)="onViewReportDetails(fault)"
                          >
                          </fieldmagic-icon>

                          <a
                            *ngIf="fault.image_path | filled"
                            href="{{ fault.image_url }}"
                            target="_blank"
                            matTooltip="{{ 'View Photo' | translate }}"
                            class="btn btn-link"
                          >
                            <fieldmagic-icon
                              icon="file-image"
                            >
                            </fieldmagic-icon>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  